import { getStoreType } from '@/utils/getStoreType';
import { STORE_CUSTOMIZATION } from './constants';

export function isStoreServiceBased() {
  return getStoreType() !== STORE_CUSTOMIZATION.ORDER_BASED;
}
